import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=f5b9cda6&scoped=true&"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=f5b9cda6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b9cda6",
  null
  
)

export default component.exports